document.addEventListener('DOMContentLoaded', function () {

  // Nav scroll shadow
  var nav = document.getElementById('site-nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('scrolled', window.scrollY > 20);
    });
  }

  // Mobile hamburger
  var btn = document.getElementById('nav-hamburger');
  var mob = document.getElementById('nav-mobile');
  if (btn && mob) {
    btn.addEventListener('click', function () {
      btn.classList.toggle('open');
      mob.classList.toggle('open');
    });
  }

  // Product gallery thumbs
  var thumbs = document.querySelectorAll('.product-img-thumb div');
  var mainImg = document.getElementById('product-main-img');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      if (mainImg && thumb.dataset.src) {
        mainImg.src = thumb.dataset.src;
      }
    });
  });

  // Add to cart flash
  document.querySelectorAll('.feat-atc, .col-atc').forEach(function (btn) {
    var form = btn.closest('form');
    if (form) {
      form.addEventListener('submit', function () {
        var orig = btn.textContent;
        btn.textContent = 'Added ✓';
        btn.style.background = '#1A7A1A';
        setTimeout(function () {
          btn.textContent = orig;
          btn.style.background = '';
        }, 2200);
      });
    }
  });

  // Fade-up on scroll
  var els = document.querySelectorAll('.feat-card,.testi-card,.col-card,.rstep,.coll-card');
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.style.opacity = '1';
          e.target.style.transform = 'translateY(0)';
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(18px)';
      el.style.transition = 'opacity .55s ease, transform .55s ease';
      obs.observe(el);
    });
  }

});
